import { Component } from '@angular/core';
import { DwModalConfig } from '@devwareapps/devware-cap';

@Component({
    selector: 'app-team-joined-modal',
    template: `
      <div class="team-celebration">
        <svg viewBox="0 0 320 190" role="img" aria-label="A team crest surrounded by colorful confetti">
          <g fill="#f5bc36"><path d="M35 30l8 8-8 8-8-8zM270 100l8 8-8 8-8-8z"/><circle cx="260" cy="28" r="6"/></g>
          <g fill="#ef6785"><path d="M67 115l6 14-9 4-6-14zM240 48l6 14-9 4-6-14z"/><circle cx="285" cy="65" r="5"/></g>
          <g fill="#48c9b0"><path d="M80 25h8v17h-8zM235 135h8v17h-8z"/><circle cx="40" cy="90" r="5"/></g>
          <path d="M160 15l67 25v58c0 39-40 64-67 78-27-14-67-39-67-78V40z" fill="#5b49ba"/>
          <path d="M160 27l55 21v50c0 29-30 52-55 66-25-14-55-37-55-66V48z" fill="#7966d5"/>
          <g fill="#fff"><circle cx="160" cy="65" r="14"/><circle cx="128" cy="77" r="10"/><circle cx="192" cy="77" r="10"/>
          <path d="M141 89q19-10 38 0v36h-38zM115 95q12-7 22 0v24h-22zM183 95q12-7 22 0v24h-22z"/></g>
          <path d="M150 139l8 8 18-19" stroke="#f5bc36" stroke-width="7" fill="none" stroke-linecap="round"/>
        </svg>
        <h2>You’re on {{ modalConfig.data.teamName }}!</h2>
        <p>Your next streak starts together. Welcome to the team!</p>
      </div>`,
    styles: [`.team-celebration{text-align:center;padding:12px 16px 28px}.team-celebration svg{width:100%;max-width:320px}.team-celebration h2{font-size:1.65rem;color:#4f3fa2}.team-celebration p{margin:14px auto 0;max-width:340px}`]
})
export class TeamJoinedModalComponent {
    modalConfig: DwModalConfig<{ teamName: string }>;
}
